<template>
  <div class="app-container">
    <div style="display: flex; margin-bottom: 15px">
      <!-- <el-form :model="listQuery" ref="filterForm" :inline="true"> -->
      <!-- label="文件夾名" prop="FOLDER_NAME"> -->
      <div style="margin-right: 15px">
        <el-input
          v-model="listQuery.FOLDER_NAME"
          placeholder="搜尋文件夾名"
          clearable
          @keyup.enter.native="handleFilter" />
      </div>
      <div>
        <el-button plain round icon="el-icon-search" @click="handleFilter"> 搜尋 </el-button>
        <el-button icon="el-icon-refresh" @click="resetForm('filterForm', listQuery, getList)"> 重置 </el-button>
        <el-button v-loading.fullscreen.lock="fullLoading" type="primary" icon="el-icon-plus" @click="handleCreate">
          新增
        </el-button>
        <el-button
          v-loading.fullscreen.lock="fullLoading"
          type="danger"
          icon="el-icon-delete"
          @click="handleBatchDelete">
          刪除
        </el-button>
      </div>
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      fit
      highlight-current-row
      border
      stripe
      row-key="ID"
      :expand-row-keys="expands"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="50px" align="center" />
      <el-table-column label="序號" type="index" align="center" width="50px" />
      <el-table-column label="文件夾名" prop="FOLDER_NAME" align="center" show-overflow-tooltip />
      <el-table-column label="更新時間" prop="LAST_UPDATE_DATE" align="center" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span>{{ row.LAST_UPDATE_DATE | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" show-overflow-tooltip class-name="small-padding fixed-width">
        <template slot-scope="{ row }">
          <el-button type="primary" size="mini" @click="handleUpdate(row)"> 修改 </el-button>
          <el-button size="mini" type="danger" @click="handleDelete(row)"> 刪除 </el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList" />

    <el-dialog
      width="800px"
      :title="textMap[dialogStatus]"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false">
      <el-form
        ref="formRef"
        class="dialog-from-margin"
        :rules="rules"
        status-icon
        :model="dataform"
        label-position="left"
        label-width="100px">
        <el-form-item label="文件夾名" prop="FOLDER_NAME">
          <el-input v-model="dataform.FOLDER_NAME" clearable show-word-limit placeholder="請輸入文件夾名" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false"> 取消 </el-button>
        <el-button type="primary" @click="dialogStatus === 'create' ? createData() : updateData()"> 確定 </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { folderInfo, createFolder, updateFolder, deleteFolder, countFolder } from '@/api/folders'
import Pagination from '@/components/Pagination' // 分页

export default {
  name: 'Folders',
  components: {
    Pagination
  },
  data() {
    const folderNameValidator = (rule, value, callback) => {
      let query
      if (this.dialogStatus === 'create') {
        query = { FOLDER_NAME: value }
      } else {
        query = { FOLDER_NAME: value, ID: this.dataform.ID }
      }
      countFolder(query).then((response) => {
        if (response.data.result > 0) {
          callback(new Error('文件夾名已存在，請重新輸入'))
        } else {
          callback()
        }
      })
    }

    return {
      list: [],
      total: 0,
      listLoading: true,
      fullLoading: false,
      // 默认展开节点
      expands: [],
      listQuery: {
        page: 1,
        limit: 10,
        FOLDER_NAME: undefined
      },
      dataform: {
        ID: undefined,
        FOLDER_NAME: undefined
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '修改',
        create: '新增'
      },
      rules: {
        FOLDER_NAME: [
          { required: true, message: '請輸入文件夾名', trigger: 'blur' },
          { validator: folderNameValidator, trigger: 'blur' }
        ]
      },
      multipleSelection: []
    }
  },
  activated: function () {
    this.getList()
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.listLoading = true
      folderInfo(this.listQuery)
        .then((response) => {
          this.expands = []
          this.list = response.data.result.rows
          this.total = response.data.result.count
          this.listLoading = false
        })
        .catch(() => {
          this.listLoading = false
        })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    resetForm(formName, query, getListMethod) {
      // this.$refs[formName].resetFields()
      query.FOLDER_NAME = undefined
      getListMethod()
    },
    resetTemp() {
      this.dataform = {
        ID: undefined,
        FOLDER_NAME: undefined
      }
    },
    handleCreate() {
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        // 重新加载上级部门数据
        this.$refs.formRef.clearValidate()
      })
    },
    createData() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          const tempData = Object.assign({}, this.dataform)
          this.fullLoading = true
          createFolder(tempData)
            .then(() => {
              this.fullLoading = false
              this.dialogFormVisible = false
              this.$notify({
                title: '成功',
                message: '新增成功',
                type: 'success',
                duration: 2000
              })
              // this.notifyMessage()
              this.getList()
            })
            .catch(() => {
              this.fullLoading = false
              this.dialogFormVisible = false
            })
        }
      })
    },
    handleUpdate(row) {
      this.dataform = Object.assign({}, row) // copy obj
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        // 重新加载上级部门数据
        this.$refs.formRef.clearValidate()
      })
    },
    updateData() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          const tempData = Object.assign({}, this.dataform)
          this.fullLoading = true
          updateFolder(tempData)
            .then(() => {
              this.fullLoading = false
              this.dialogFormVisible = false
              // this.notifyMessage()
              this.$notify({
                title: '成功',
                message: '修改成功',
                type: 'success',
                duration: 2000
              })
              // this.getList()
              const udata = this.list.find((x) => x.ID === tempData.ID)
              udata.FOLDER_NAME = tempData.FOLDER_NAME
            })
            .catch(() => {
              this.fullLoading = false
              this.dialogFormVisible = false
            })
        }
      })
    },
    handleDelete(row) {
      this.$confirm('確認刪除該記錄？', '提示', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.fullLoading = true
          deleteFolder(row.ID)
            .then(() => {
              this.fullLoading = false
              this.$notify({
                title: '成功',
                message: '刪除成功',
                type: 'success',
                duration: 2000
              })
              this.handleFilter()
            })
            .catch(() => {
              this.fullLoading = false
            })
        })
        .catch(() => {
          // 不執行任何動作
        })
    },
    handleBatchDelete() {
      if (!this.multipleSelection.length) {
        this.$message({ type: 'info', message: '請勾選你要刪除的數據' })
        return
      }

      this.$confirm('確認刪除該記錄？', '提示', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.fullLoading = true
          const promises = []

          this.multipleSelection.forEach((id) => {
            promises.push(deleteFolder(id))
          })

          Promise.all(promises)
            .then(() => {
              this.fullLoading = false
              this.$notify({
                title: '成功',
                message: '刪除成功',
                type: 'success',
                duration: 2000
              })
              this.handleFilter()
            })
            .catch(() => {
              this.fullLoading = false
            })
        })
        .catch(() => {
          // 不執行任何動作
        })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val.map((item) => item.ID)
    }
  }
}
</script>
